<template>
  <el-dialog
    :visible="visible"
    @close="closeDialog"
    top="5vh"
    width="80%"
    center
    :title="title"
  >
    <el-form :model="form" ref="uploadForm" label-width="120px">
      <el-row :gutter="24">
        <el-form-item style="margin-left: -120px">
          <div
            style="
              text-align: center;
              margin-top: -20px;
              display: flex;
              justify-content: space-between;
            "
          >
            <h3>Ejemplo de formato (archivo)</h3>

            <div
              class="upload-form"
              style="display: flex; flex-direction: inherit"
            >
              <div class="file-input-wrapper">
                <input
                  type="file"
                  ref="fileInput"
                  accept=".csv"
                  @change="handleFileChange"
                />

                <el-button class="file-input-button">
                  <strong v-if="!form.file">Seleccionar Archivo</strong>
                  <strong v-else>{{ form.file.name }}</strong>
                </el-button>
              </div>
            </div>
          </div>

          <el-table
            :data="example"
            style="width: 100%; margin-bottom: 20px"
            stripe
          >
            <el-table-column label="covered" align="center">
              <template slot-scope="props">
                <strong>
                  <i class="el-icon-user"></i>
                  {{ props.row.covered }}
                </strong>
              </template>
            </el-table-column>

            <el-table-column label="code" align="center">
              <template slot-scope="props">
                <strong>
                  <i class="el-icon-user"></i>
                  {{ props.row.postalCode }}
                </strong>
              </template>
            </el-table-column>

            <el-table-column label="ocurre" align="center">
              <template slot-scope="props">
                <strong>
                  <i class="el-icon-user"></i>
                  {{ props.row.ocurre }}
                </strong>
              </template>
            </el-table-column>

            <el-table-column label="days" align="center">
              <template slot-scope="props">
                <strong>
                  <i class="el-icon-user"></i>
                  {{ props.row.days }}
                </strong>
              </template>
            </el-table-column>

            <el-table-column label="sector" align="center">
              <template slot-scope="props">
                <strong>
                  <i class="el-icon-user"></i>
                  {{ props.row.sector }}
                </strong>
              </template>
            </el-table-column>

            <el-table-column label="service" align="center">
              <template slot-scope="props">
                <strong>
                  <i class="el-icon-user"></i>
                  {{ props.row.service }}
                </strong>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="coverages.length">
            <h3>Coberturas con direcciónes o códigos postales incorrectos</h3>

            <el-table
              :data="coverages"
              style="width: 100%; margin-bottom: 20px"
              stripe
            >
              <el-table-column label="code" align="center">
                <template slot-scope="props">
                  <strong>
                    <i class="el-icon-user"></i>
                    {{ props.row.code }}
                  </strong>
                </template>
              </el-table-column>

              <el-table-column label="ocurre" align="center">
                <template slot-scope="props">
                  <strong>
                    <i class="el-icon-user"></i>
                    {{ props.row.ocurre }}
                  </strong>
                </template>
              </el-table-column>

              <el-table-column label="days" align="center">
                <template slot-scope="props">
                  <strong>
                    <i class="el-icon-user"></i>
                    {{ props.row.days }}
                  </strong>
                </template>
              </el-table-column>

              <el-table-column label="sector" align="center">
                <template slot-scope="props">
                  <strong>
                    <i class="el-icon-user"></i>
                    {{ props.row.sector }}
                  </strong>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="display: flex; justify-content: space-between">
            <el-button @click="closeDialog">Cancelar</el-button>
            <el-button type="primary" @click="uploadCSV">Subir</el-button>
          </div>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { CSApi } from "@/libraries/api";

export default {
  name: "DialogUploadCoverage",
  props: ["visible"],
  data() {
    return {
      title: "Carga Masiva por CSV",
      form: {
        file: null,
      },
      coverages: [],
      example: [
        {
          covered: true,
          outOfArea: false,
          outOfPickup: false,
          ocurre: false,
          days: 2,
          postalCode: "64000",
          sector: "optional",
          service: "id del servicio",
        },
      ],
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    handleFileChange(event) {
      this.form.file = event.target.files[0];
    },
    update() {
      this.$emit("update");
    },
    async uploadCSV() {
      if (!this.form.file) {
        this.$message.error("Por favor, seleccione un archivo.");
        return;
      }

      const formData = new FormData();
      formData.append("addresses", this.form.file);

      try {
        const response = await CSApi().post(
          "/coverage/postalCode/csv",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.success) {
          this.$message.success("Archivo subido exitosamente.");

          this.update();

          if (response.data.data.wrongCoverages?.length) {
            this.coverages = response.data.data.wrongCoverages;
            return;
          }

          this.closeDialog();
          return;
        }
        this.$message.error("Error al subir el archivo.");
      } catch (error) {
        this.$message.error("Error al subir el archivo.");
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 55px;
  width: 330px;
}
.el-form-item__label {
  font-size: 14px;
  font-weight: 100;
  line-height: 14px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  font-weight: 100;
}
.el-input .el-input--small .el-input--suffix {
  width: 260px;
}

.upload-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.file-input-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.file-input-button {
  background-color: #409eff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  cursor: pointer;
}

.file-input-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.file-name {
  font-weight: bold;
  font-size: 16px;
  text-align: center;
}
</style>
